



























































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import modalState from "@/common/store/modules/modalState";

@Component({
  components: {
    IconBase,
    IconArrowBottom
  },
  filters: {
    truncate(value: any, length = 20, omission = "...") {
      const stringLength = parseInt(length.toString(), 10);
      const stringOmmision = omission.toString();

      if (!stringLength || (value && value.length <= stringLength)) {
        return value;
      }
      return value.substring(0, stringLength) + stringOmmision;
    }
  }
})
export default class HeaderCategoryNavi extends Vue {
  @Prop({ type: String, default: "商品カテゴリー" }) defaultLabel!: string;
  @Prop({ type: String, default: "#000000" }) iconColor!: string;
  @Prop({ type: String, default: "#000000" }) textColor!: string;
  @Prop({ type: [Boolean, Number], default: false }) trimTextLength!: boolean;
  @Prop({ type: String, required: true }) idPrefix!: string;
  @Prop({ type: [String, Number], default: "all", required: true })
  currentCategoryValue!: string | number;
  @Prop({ type: Object }) currentCategoryObject: any;
  @Prop({ type: String, default: "auto" }) buttonWidth!: string;
  @Prop({ type: String, required: false }) type!: string;
  @Prop({
    default: () => {
      return [];
    }
  })
  categories!: any;

  value!: any;

  shown = false;
  switchState = false;
  catValue = "";

  currentCategoryLabel = "";
  headerInfo = commons.headerInfo;

  get itemCategories() {
    let categories = this.categories;
    if (!categories) {
      categories = [];
    }
    return categories;
  }

  @Watch("catValue")
  onCatValue(value: number) {
    const catObject = this.getCategoryObject(value);
    this.currentCategoryLabel = catObject.name;
    this.$emit("update:currentCategoryValue", catObject.id);
    this.$emit("update:currentCategoryObject", {
      id: catObject.id,
      name: catObject.name
    });
  }

  getCategoryObject(catId: number) {
    const itemCategories = this.itemCategories;
    const newCategoryObject = itemCategories.find((item: any) => {
      if (item.id === catId) {
        return item;
      }
      return false;
    });

    return newCategoryObject;
  }

  get zIndexStyle() {
    const { shown } = this;
    const zIndex = shown ? 2 : 0;

    return { zIndex };
  }

  get buttonClass() {
    const { buttonWidth } = this;
    const classNameBase = "p-header-category-navi__heading";
    const resultIndex = buttonWidth === "auto" ? "auto" : "other";
    const resultClassName = {
      auto: [`${classNameBase}--category`],
      other: [`${classNameBase}--search`]
    };

    return resultClassName[resultIndex];
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  @Watch("closeModalState")
  onCloseModalState() {
    this.shown = false;
  }

  created() {
    if (this.currentCategoryObject) {
      this.currentCategoryLabel = this.currentCategoryObject.name;
      this.$emit("update:currentCategoryValue", this.currentCategoryObject.id);
      this.$emit("update:currentCategoryObject", {
        id: this.currentCategoryObject.id,
        name: this.currentCategoryObject.name
      });
    }

    if (this.type == undefined) {
      setTimeout(() => {
        this.currentCategoryLabel = this.currentCategoryObject.name;
        this.$emit(
          "update:currentCategoryValue",
          this.currentCategoryObject.id
        );
        this.$emit("update:currentCategoryObject", {
          id: this.currentCategoryObject.id,
          name: this.currentCategoryObject.name
        });
      }, 1000);
    }
  }

  viewCategoryProducts(id: number) {
    if (this.type == "top") {
      this.shown = !this.shown;
    } else {
      window.location.href = "/product-list/?product-category=" + id;
    }
  }

  switchShownState() {
    this.shown = !this.shown;
  }
}
